import React from "react";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const one = (
      <p>
        I am currently a <b>Data Scientist</b> at
        <a href="https://jobs.disneycareers.com/our-work"> The Walt Disney Company</a>, 
        working in <b>Disney Entertainment & ESPN Technology</b>. Simultaneously, I am 
        pursuing a part-time <b>Masters in Computer Science</b> from <a href="https://omscs.gatech.edu/"> Georgia Tech</a>.
      </p>
    );
    const two = (
      <p>
        In my free time, I enjoy drawing iPad illustrations, reading, and drinking tea.
      </p>
    );
    
    const desc_items = [one, two];

    const tech_stack = [
      "Python",
      "SQL",
      "Snowflake",
      "AWS",
      "Docker",
      "Airflow"
    ];

    const tech_items = tech_stack.map(stack => <li>{stack}</li>);
    var image = require("./assets/me.jpeg");

    return (
      <div id="about">
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">About me</span>
          </div>
          <div className="about-content">
            <div className="about-description">
              {desc_items}
              {"Tools utilized daily:"}
              <ul className="tech-stack">
                {tech_stack.map(function (tech_item, i) {
                  return (
                    <FadeInSection delay={`${i + 1}00ms`}>
                      <li>{tech_item}</li>
                    </FadeInSection>
                  );
                })}
              </ul>
            </div>
            <div className="about-image">
              <img src={image} />
            </div>
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default About;
